/**
 * @generated SignedSource<<42fd12ef6995bd70f17e3ea656f9363f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_user" | "HpSharedVideoComponentVideo_user">;
  readonly " $fragmentType": "HpSharedVideoComponent_user";
};
export type HpSharedVideoComponent_user$key = {
  readonly " $data"?: HpSharedVideoComponent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentVideo_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3ea795247c135f333c80e5465bc7ce60";

export default node;
